export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/v1/auth/login',
    CODE: '/api/v1/auth/login-one-id',
    ME: '/api/v1/auth/me',
    ME_UPDATE: '/api/v1/auth/update',
  },
  ONE_ID: {
    PIN: '/api/v1/one-id/user/:pin',
  },
  APPLICATION: {
    FIND_ALL: '/api/v1/applications',
    FIND_ONE: '/api/v1/applications/:id',
    MY_GOV_GET: '/api/v1/epigu/attestations/med-specialist',
    MY_GOV_GET_CHANGE: '/api/v1/applications/mygov/med-specialist',
    MY_GOV_INVOICE: '/api/v1/applications/get-mygovuz-payments/:id',
    MY_GOV_GET_CHECK: '/api/v1/applications/get-mygovuz-applications/:id',
    APPLICATION_GET_CHECK: '/api/v1/applications',
    HISTORY: '/api/v1/application-history',
    CHECK_DIPLOMAS: '/api/v2/mip/minvuz/diploma/:pinfl',
    HISTORY_CURRENT: '/api/v2/mip/current-position/',
    HISTORY_WORK: '/api/v2/mip/position-history/',
    EXAM_DATA: '/api/v1/examdates',
    EXAM_DATA_RESULT: '/api/v1/examdates/test-result',
    EXAM_DATA_ORAL: '/api/v1/examdates/interview',
    EXAM_DATA_ORAL_SECOND: '/api/v1/examdates/interview-second',
    UPDATE_ONE: '/api/v1/applications/:id',
    UPDATE_CERTIFICATE: '/api/v1/applications/update/:id',
    PATCH_ONE: '/api/v1/applications/:id',
    DELETE_ONE: '/api/v1/applications/:id',
    CREATE_ONE: '/api/v1/applications',
    UPLOAD: '/api/v1/applications/yaratish',
    UPDATE: '/api/v1/applications/yangilash/:id',
    UPLOAD_FILE: '/api/v1/admin/media',
    UPLOAD_CERTIFICATES: '/api/v1/applications/import',
    UPLOAD_TEST_TAKERS: '/api/v1/applications/change-status-to-test-takers',
    UPLOAD_TEST_TAKERS_TO_OTHERS: '/api/v1/applications/change-test-takers-status-to-another',
    UPLOAD_VERBAL_TO_OTHER: '/api/v1/applications/import-result',
    UPLOAD_VERBAL_TO_TWICE:
      '/api/v1/applications/change-verbal-passers-status-to-who-didnot-come-twice',
    UPLOAD_INVOICE: '/api/v1/applications/invoice/:id',
    CONFIRM_ONE: '/api/v1/applications/:id/confirm',
    DECLINE_ONE: '/api/v1/applications/:id/decline',
    STATS: '/api/v1/applications/stats',
    NOTIFICATIONS: '/api/v1/applications/notifications',
    CHANGE_STATUS: '/api/v1/applications/:id/change-status',
  },
  APPEALS: {
    FIND_ALL: '/api/v1/appeals',
    CREATE_ONE: '/api/v1/appeals',
    GET_LATEST: '/api/v1/appeals/current',
    CONFIRM_ONE: '/api/v1/appeals/confirm',
    DECLINE_ONE: '/api/v1/appeals/decline',
  },
  ATTESTATION: {
    FIND_ONE: '/api/v1/attestations/:id',
    CURRENT: '/api/v1/attestations/current',
    ABSENT: '/api/v1/attestations/:id/absent',
    START: '/api/v1/attestations/:id/start',
    COMPLETE: '/api/v1/attestations/:id/complete',
    STOP: '/api/v1/attestations/:id/stop',
    GET_APPLICANTS: '​/api/v1/attestations/applicants',
  },
  DIRECTION: {
    FIND_ALL: '/api/v1/directions',
    FIND_ONE: '/api/v1/directions/:id',
    UPDATE_ONE: '/api/v1/directions/:id',
    PATCH_ONE: '/api/v1/directions/:id',
    DELETE_ONE: '/api/v1/directions/:id',
    CREATE_ONE: '/api/v1/directions',
  },
  DISTRICT: {
    FIND_ALL: '/api/v1/districts',
    FIND_ONE: '/api/v1/districts/:id',
    UPDATE_ONE: '/api/v1/districts/:id',
    PATCH_ONE: '/api/v1/districts/:id',
    DELETE_ONE: '/api/v1/districts/:id',
    CREATE_ONE: '/api/v1/districts',
  },
  LOCATION: {
    FIND_ALL: '/api/v1/locations',
    FIND_ONE: '/api/v1/locations/:id',
    UPDATE_ONE: '/api/v1/locations/:id',
    PATCH_ONE: '/api/v1/locations/:id',
    DELETE_ONE: '/api/v1/locations/:id',
    CREATE_ONE: '/api/v1/locations',
  },
  ORGANIZATION: {
    FIND_ALL: '/api/v1/organizations',
    FIND_ONE: '/api/v1/organizations/:id',
    UPDATE_ONE: '/api/v1/organizations/:id',
    PATCH_ONE: '/api/v1/organizations/:id',
    DELETE_ONE: '/api/v1/organizations/:id',
    CREATE_ONE: '/api/v1/organizations',
  },
  REGION: {
    FIND_ALL: '/api/v1/regions',
    FIND_ONE: '/api/v1/regions/:id',
    UPDATE_ONE: '/api/v1/regions/:id',
    PATCH_ONE: '/api/v1/regions/:id',
    DELETE_ONE: '/api/v1/regions/:id',
    CREATE_ONE: '/api/v1/regions',
  },
  COMMISSION: {
    FIND_ALL: '/api/v1/commissions',
    FIND_ONE: '/api/v1/commissions/:id',
    UPDATE_ONE: '/api/v1/commissions/:id',
    PATCH_ONE: '/api/v1/commissions/:id',
    DELETE_ONE: '/api/v1/commissions/:id',
    CREATE_ONE: '/api/v1/commissions',
  },
  SPECIALIZATION: {
    FIND_ALL: '/api/v1/specializations',
    FIND_ONE: '/api/v1/specializations/:id',
    UPDATE_ONE: '/api/v1/specializations/:id',
    PATCH_ONE: '/api/v1/specializations/:id',
    DELETE_ONE: '/api/v1/specializations/:id',
    CREATE_ONE: '/api/v1/specializations',
  },
  SCHEDULE: {
    FIND_ALL: '/api/v1/schedules',
    FIND_ONE: '/api/v1/schedules/:id',
    UPDATE_ONE: '/api/v1/schedules/:id',
    PATCH_ONE: '/api/v1/schedules/:id',
    DELETE_ONE: '/api/v1/schedules/:id',
    CREATE_ONE: '/api/v1/schedules',
  },
  USER: {
    FIND_ALL: '/api/v1/users',
    FIND_ADMINS: '/api/v1/users/admins',
    FIND_ONE: '/api/v1/users/:id',
    UPDATE_ONE: '/api/v1/users/:id',
    PATCH_ONE: '/api/v1/users/:id',
    DELETE_ONE: '/api/v1/users/:id',
    CREATE_ONE: '/api/v1/users',
    UPDATE_PROFILE: '/api/v1/users/:id/update',
  },
  JOB: {
    CURRENT_POSITION: '/api/v1/mip/current-position/:pinfl',
    POSITION_HISTORY: '/api/v2/mip/position-history/:pinfl',
  },
  QUESTION: {
    FIND_ALL: '/api/v1/questions',
    FIND_ONE: '/api/v1/questions/:id',
    CREATE_ONE: '/api/v1/questions',
    UPDATE_ONE: '/api/v1/questions/:id',
    DELETE_ONE: '/api/v1/questions/:id',
    UPLOAD: '/api/v1/questions/import',
    FIELDS: '/api/v1/questions/fields',
    CATEGORIES: '/api/v1/questions/categories',
    DIFFICULTY_LEVELS: '/api/v1/questions/difficulty-levels',
  },
  CERTIFICATE: {
    FIND_FILE: '/api/v1/certificates/:uid.pdf',
  },

  NEWS: {
    FIND_ALL: '/api/v1/news',
    FIND_ONE: '/api/v1/news/:id',
    LANGUAGE_LINKS: '/api/v1/language-links/news/:id',
  },
  FAQ: {
    FIND_ALL: '/api/v1/faq',
  },
};
